module.exports = __webpack_public_path__ + "static/media/venezuela.f136cd4b.svg";